var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tw"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse 23",
    cx: 11.8748,
    cy: 11.4349,
    r: 10.72,
    stroke: "#EFEFF0",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon simple-twitter",
    d: "M16.5464 8.53087C16.2006 8.68289 15.8313 8.78645 15.4424 8.83374C15.8387 8.59496 16.1435 8.21862 16.2877 7.7696C15.9161 7.98649 15.5041 8.14437 15.0656 8.2323C14.7155 7.85753 14.2164 7.62305 13.6622 7.62305C12.6004 7.62305 11.7394 8.48398 11.7394 9.5446C11.7394 9.69702 11.757 9.84357 11.789 9.98386C10.1906 9.90844 8.77388 9.14091 7.82575 7.98063C7.65888 8.26278 7.56547 8.59066 7.56547 8.94785C7.56547 9.61612 7.90548 10.2035 8.42058 10.5486C8.10519 10.5384 7.80856 10.4516 7.54984 10.3078V10.3317C7.54984 11.2637 8.21149 12.041 9.092 12.2181C8.93059 12.2614 8.7602 12.2849 8.5855 12.2849C8.46279 12.2849 8.34515 12.2732 8.22751 12.2513C8.47412 13.0145 9.18306 13.571 10.0268 13.5866C9.37026 14.1021 8.53821 14.4093 7.64207 14.4093C7.48965 14.4093 7.33762 14.4003 7.18481 14.3831C8.04031 14.9279 9.04823 15.2464 10.1382 15.2464C13.6767 15.2464 15.6093 12.3169 15.6093 9.78065C15.6093 9.69897 15.6093 9.61651 15.6034 9.53444C15.979 9.26518 16.3069 8.9248 16.5648 8.53869L16.5464 8.53087Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.0e96fcf730d4f53afe5d24baa9c2df05.svg";
export { ForwardRef as ReactComponent };